import { render, staticRenderFns } from "./addCollectionCompanyComponent.vue?vue&type=template&id=349901f7&"
import script from "./addCollectionCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./addCollectionCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports